// import MachproHTMLElement from './common/machproHtmlElement';
import Text from './Text';

class AdaptiveText extends Text {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
  }
}

export default AdaptiveText;
